import axios from "axios";

export const send_data = ( server: string , token: string, bewohner_id: any, rezept: any, menge: any, zeit: any, datumsql: any) => {
  const config = {
    method: "post",
    url:
      `${ server }/funktionen/api2/senioren/rezept_buchen.php?bewohner_id=${ bewohner_id }&rezept=${ rezept }&menge=${ menge }&zeit=${ zeit }&datum=${ datumsql }`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  axios(config)
    .then(() => {})
    .catch(() => console.error("FEHLER:", "Fehler beim Buchen (Code 25feb05-1043)"));
}
